import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IMG_BASE_URL } from "../../../../config/Config";
import { useNavigate } from "react-router-dom";
const Main_Slider = (homeData) => {
  const navigate = useNavigate()
  const Get_Main_Slider = homeData?.data?.sliders || [];
  const category = homeData?.data?.category || [];
  const gemstoneCategory = category?.find(cat => cat?.id === 1);
  const jewelleryCategory = category?.find(cat => cat?.id === 2);

  const MainSliderWithVideo = [...Get_Main_Slider];

  // Track current slide
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    infinite: MainSliderWithVideo.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: MainSliderWithVideo.length > 1,
    autoplaySpeed: 3000,
    dots: true,
    arrows: true,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    appendDots: (dots) => (
      <div style={{ position: "absolute", bottom: "20px", width: "100%", marginBottom: "10px" }}>
        <ul className="slick-dots flex justify-center"> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        className={`w-3 h-3 rounded-full mx-1 transition-all duration-300 ${i === currentSlide ? "bg-red-500 scale-110" : "bg-gray-400"
          }`}
      ></div>
    ),
  };

  const navigationHandler = (navigation_type, url) => {
    const routeMap = {
      'book-pooja': '/pooja',
      'astrologer': '/astrologer-list',
      'pandit': '/pandit-list',
      'gemstone': gemstoneCategory?.slug ? `/${gemstoneCategory.slug}` : null,
      'jewellery': jewelleryCategory?.slug ? `/${jewelleryCategory.slug}` : null,
    };

    if (navigation_type === 'url' && url) {
      window.location.href = url
      return;
    }
    else if (routeMap[navigation_type]) {
      navigate(routeMap[navigation_type]);
      return;
    }
    else {
      console.warn(`Unrecognized navigation type: ${navigation_type}`);
      return; // Do nothing if navigation_type is unrecognized
    }

  };


  return (
    <section className="section gi-hero w-full max-w-full overflow-hidden relative -mb-[8px]">
      <div className="flex flex-wrap justify-between items-center mx-auto">
        <div className="gi-main-content w-full">
          {/* Hero Slider Start */}
          <div className="gi-slider-content relative z-0">
            <Slider {...settings}>
              {MainSliderWithVideo?.length > 0 ? (
                MainSliderWithVideo.map((slide, index) => (
                  <div key={index} className="relative">
                    <div onClick={() => navigationHandler(slide?.navigation_type, slide?.url)} className="w-full cursor-pointer">

                      {slide.img_vid == 'video' ? (
                        <video
                          src={`${IMG_BASE_URL}${slide?.video}`}
                          className="w-[100%] object-fill bg-center aspect-[calc(4*3+1)/4]"
                          autoPlay
                          loop
                          muted
                          playsInline
                          poster={slide.image || undefined} // optional fallback thumbnail
                        // width={483}
                        // height={440}
                        />
                      ) : (
                        <img
                          src={`${IMG_BASE_URL}${slide?.image}`}
                          className="w-full object-fill aspect-[calc(4*3+1)/4]"
                          alt={`Banner ${index + 1}`}
                          fetchpriority="high"
                          decoding="async"
                          loading="eager"
                        />
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p className="text-center">No slides available</p>
                </div>
              )}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Main_Slider;
